<div class="grid">
    <div class="col-12">
        <div class="flex gap-4 mt-4">
            <p-fileupload #fileUploader name="file" mode="basic" (onSelect)="onFileSelect($event)" [auto]="false"
                          chooseLabel="Pick a File" [customUpload]="true">
            </p-fileupload>

            <p-progressSpinner styleClass="w-3rem h-3rem" *ngIf="busy"></p-progressSpinner>
            <p-button [disabled]="!selectedFile || busy" label="Process"
                      (click)="processDocument(fileUploader)"></p-button>

            <p-button [disabled]="!selectedFile || busy" label="Import"
                      (click)="importDocument(fileUploader)"></p-button>
        </div>
    </div>

    <div class="col-12">
        <em-schema-runtime-data
                *ngIf="emSchemaRuntimeDataDto"
                [schemaData]="emSchemaRuntimeDataDto"
        ></em-schema-runtime-data>
    </div>
</div>